import { BaseService } from "./common/base";

export class DispatchService extends BaseService {
  constructor() {
    super("dispatch");
  }

  find(): Promise<{
    serviceRequests: any[];
    assistants: any[];
    doctors: any[];
  }> {
    return super.find() as any;
  }

  assignPerformers(
    id: string,
    participants: { userType: string; id: string }[],
  ) {
    return super._post(`/assign-performers/${id}`, participants);
  }
}
